import { defineComponent } from "vue";
import EventBus from "@/utils/EventBus";

export default defineComponent({
  data() {
    return {
      websocket: null,
      reconnectInterval: 5000,
      maxRetries: 10,
      retries: 0,
    };
  },
  mounted() {
    this.connect();
  },
  methods: {
    connect() {
      const websocket = new WebSocket(process.env.VUE_APP_SOCKET_URL as string);
      websocket.onopen = () => {
        console.log("Connected to WebSocket server");
      };
      websocket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        console.log("data", data)
        if (data.event == "event-updated") {
          EventBus.emit("reload-history", data.data.game_slug);
        }
      };
      websocket.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      websocket.onclose = () => {
        if (this.retries < this.maxRetries) {
          setTimeout(() => {
            this.retries++;
            console.log(`Reconnecting... Attempt ${this.retries}`);
            this.connect();
          }, this.reconnectInterval);
        } else {
          console.log('Max retries reached. Unable to reconnect.');
        }
      };
    }
  },
});
